module.exports = __webpack_public_path__ + "img/rank2.7cbf0153.png";